// Auto-generated by scripts/generate-registry.mjs from packages/modules/teacher_20_11_medal/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const teacher_20_11_medal: ModuleSchema = {
  "id": "teacher_20_11_medal",
  "uniqueId": "B3D_SJXSH",
  "createdAt": "2026-10-19T00:00:00Z",
  "updatedAt": "2026-10-21T07:30:52.322Z",
  "label": "Teacher Tribute Medal",
  "description": "Four-layer flower medal with curved Vietnamese tribute text, open book, pen, and flower ornament",
  "category": "app_model",
  "tags": [
    "teacher-gift",
    "medal",
    "four-layer"
  ],
  "sliders": [
    {
      "key": "size",
      "label": "Overall Size",
      "min": 25,
      "max": 50,
      "default": 50,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1,
        2,
        3
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "textOffsetX",
      "label": "Text Position X",
      "min": -12,
      "max": 12,
      "default": 1,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "textOffsetY",
      "label": "Text Position Y",
      "min": -12,
      "max": 12,
      "default": -1,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "textWidthXY",
      "label": "Text Width (XY)",
      "min": 5,
      "max": 50,
      "default": 29.5,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        1
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "bookOffsetX",
      "label": "Book and Pen Position X",
      "min": -12,
      "max": 12,
      "default": 1,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        2
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "bookOffsetY",
      "label": "Book and Pen Position Y",
      "min": -12,
      "max": 12,
      "default": -3,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        2
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "bookScaleXY",
      "label": "Book and Pen Scale (XY)",
      "min": 0.5,
      "max": 1.5,
      "default": 0.95,
      "step": 0.05,
      "unit": "×",
      "targetGroupIds": [
        2
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "flowersOffsetX",
      "label": "Flower Ornament Position X",
      "min": -12,
      "max": 12,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        3
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "flowersOffsetY",
      "label": "Flower Ornament Position Y",
      "min": -12,
      "max": 12,
      "default": -0.5,
      "step": 0.5,
      "unit": "mm",
      "targetGroupIds": [
        3
      ],
      "enabled": true,
      "visible": true
    },
    {
      "key": "flowersScaleXY",
      "label": "Flower Ornament Scale (XY)",
      "min": 0.5,
      "max": 1.5,
      "default": 1.4,
      "step": 0.05,
      "unit": "×",
      "targetGroupIds": [
        3
      ],
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Curved Text",
      "default": "MỪNG 20.11",
      "kind": "text",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "body_shell",
      "label": "Main Body Shell",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "main_body",
      "label": "Template Model Body",
      "name": "Template Model Body",
      "color": "#64748b",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "body_shell",
          "label": "Main Body Shell",
          "name": "Main Body Shell",
          "groupId": 0,
          "colorKey": "body_shell",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Medal"
    },
    {
      "id": "0",
      "label": "Download STL - Flower Base"
    },
    {
      "id": "1",
      "label": "Download STL - Curved Text"
    },
    {
      "id": "2",
      "label": "Download STL - Book and Pen"
    },
    {
      "id": "3",
      "label": "Download STL - Three Flowers"
    }
  ]
};
